/**
 * A basic wrapped around fetch().
 *  - treats !response.ok as an error
 *  - adds error.response to thrown errors
 *  - better error messages
 * @param url
 * @param options options to pass to fetch https://developer.mozilla.org/en-US/docs/Web/API/fetch
 * @returns fetch response
 */
export default async function request(url: string, options: any) {
  let response;
  try {
    response = await fetch(url, options);
  } catch (error: any) {
    if (error.message === "NetworkError when attempting to fetch resource.") {
      // Augment the error message with a hint of common causes.
      error.message +=
        "This may be caused by expired credentials or CORS issues.";
    }
    // Add the response for convenience.
    error.response = response;
    throw error;
  }

  if (!response.ok) {
    let error: any = new Error(
      `Response status code was not 200 | Code: ${response.status} | URL: ${url}`
    );
    // Add the response for convenience.
    error.response = response;
    throw error;
  }

  return response;
}
